export default __webpack_public_path__ + "static/media/graf02.7ad119fc.png";